"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigation = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function useNavigation() {
    const history = react_router_dom_1.useHistory();
    const { state } = react_router_dom_1.useLocation();
    const [prompts, setPrompts] = react_1.useState([]);
    const dialogRef = react_1.useRef(null);
    const callbackRef = react_1.useRef();
    const navigateInternal = event_callback_hook_1.useEventCallback((url, replace, state) => {
        if (replace) {
            history.replace(url, state);
        }
        else {
            history.push(url, state);
        }
    });
    const testPrompts = event_callback_hook_1.useEventCallback((callback) => {
        var _a;
        if (prompts.length > 0) {
            callbackRef.current = callback;
            (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
        }
        else {
            callback();
        }
    });
    const navigate = event_callback_hook_1.useEventCallback((url, replace = false, state = undefined) => {
        testPrompts(() => {
            navigateInternal(url, replace, state);
        });
    });
    const registerPrompt = event_callback_hook_1.useEventCallback((prompt) => {
        if (!prompts.includes(prompt)) {
            setPrompts([...prompts, prompt]);
        }
    });
    const unregisterPrompt = event_callback_hook_1.useEventCallback((prompt) => {
        if (prompts.includes(prompt)) {
            setPrompts(prompts.filter((p) => p !== prompt));
        }
    });
    const promptConfirm = event_callback_hook_1.useEventCallback(() => {
        const callback = callbackRef.current;
        callbackRef.current = undefined;
        prompts.forEach((prompt) => prompt.clearCallback !== undefined && prompt.clearCallback());
        setPrompts([]);
        callback();
    });
    const promptCancel = event_callback_hook_1.useEventCallback(() => {
        callbackRef.current = undefined;
    });
    const context = react_1.useMemo(() => ({
        prompts,
        navigate,
        testPrompts,
        registerPrompt,
        unregisterPrompt,
        stateAction: state != null ? state : null,
    }), [prompts, navigate, testPrompts, registerPrompt, unregisterPrompt, state]);
    return { context, dialogRef, prompts, promptConfirm, promptCancel };
}
exports.useNavigation = useNavigation;
//# sourceMappingURL=navigation-hook.js.map